<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="search.cnsuo" placeholder="schema"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addAuthor">新建</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="app名称">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="授权类型">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="鉴权字段">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300px">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="editAuthor(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="deleteAuthor(scope.row)">删除</el-button>
          <el-button type="info" size="small" @click="secret(scope.row)">密钥</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增修改 -->
    <el-dialog title="新增/编辑授权" v-model="dialogFormVisible" width="600px">
      <el-form :model="form">
        <el-form-item label="schema" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="定向地址" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="授权码选择" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="鉴权字段" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="addconfirm">新增</el-button>
          <!-- <el-button type="primary" v-if="edit" @click="editconfirm">修改</el-button> -->
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        cnsuo: '',
        cocn: '',
      },
      list: [
        {describe: '一个毛栗子'}
      ],
      dialogFormVisible: false,
      edit: false,
      form: {}
    }
  },
  computed: {},
  watch: {},
  methods: {
    addAuthor () {
        this.dialogFormVisible = true
        this.edit = false
    },
    editAuthor () {

    },
    addconfirm (){

    },
    deleteAuthor(item) {
      this.$confirm('是否删除该工厂?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    secret (){

    }
  },
  filters: {},
  mounted () { },
  created () { }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
